import { Flex } from '@chakra-ui/react';
import { useEffect, useState } from 'react';

import { UserCreditSelectCard } from '~/components/common/credits/UserCreditSelectCard';
import { GmoCredit } from '~/types/resources/gmo_credit';

type Props = {
  credits: GmoCredit[];
  setCardSeq: (card_seq: string | null) => void;
  mutate: () => void;
};

export const UserCreditSelectList: React.FC<Props> = (props: Props) => {
  const [selectedCardSeq, setSelectedCardSeq] = useState<string | null>(null);

  useEffect(() => {
    if (props.credits?.length > 0) {
      const initialCardSeq = props.credits[0].cardSeq;
      setSelectedCardSeq(initialCardSeq);
      props.setCardSeq(initialCardSeq);
    }
  }, [props.credits]);

  if (!Array.isArray(props.credits)) return null;
  if (props.credits?.length < 1) return null;

  return (
    <Flex flexDir="column">
      {props.credits?.map((credit, key) => {
        return (
          <UserCreditSelectCard
            credit={credit}
            isChecked={selectedCardSeq === credit.cardSeq}
            setSelectedCardSeq={setSelectedCardSeq}
            setValue={props.setCardSeq}
            mutate={props.mutate}
            key={key}
          />
        );
      })}
    </Flex>
  );
};
